import { reduxForm } from 'redux-form';
import { I18n } from 'react-redux-i18n';

import { getAuthUser } from '../../../redux/actions/authActions';
import CNPJValidator from '../../validators/CNPJValidator';


const FORM_NAME = 'CompanyForm';
export const BACK_ROUTE = 'Company/EditCompany';

const FORM_DEFINITION = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true,
  fields: ['name', 'userIdCreated', 'dateCreated'],
  initialValues: {
    dateCreated: new Date(),
  },
  validate: (values) => {

    
    const errors = {};
    const requiredFields = ['name', 'cnpj'];
    requiredFields.forEach((field) => {

      if (!values[field]) errors[field] = I18n.t('messages.required_field');

      if (values.cnpj && values.cnpj.toString().length && !CNPJValidator(values.cnpj))
        errors.cnpj = I18n.t('messages.invalid_cnpj');


    });
    return errors;

  },
});

export {
  FORM_NAME,
  FORM_DEFINITION,
};



// WEBPACK FOOTER //
// ./src/components/tracker/Company/index.js